export const replaceCodeSnippetPlaceHolder = (snippets, placeholder, value) => {
    return Object.keys(snippets).reduce((accumulator, currentValue) => {
        accumulator[currentValue] = snippets[currentValue].replace(placeholder, value);
        return accumulator;
    }, {});
};
